"use strict";
/**
 * @author tatevik.marikyan
 * @since 09/07/2018
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var model_1 = require("./model");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var utilities_1 = require("../../utilities");
var abstract_destruction_subject_1 = require("../../abstract-destruction-subject");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var zip_1 = require("rxjs/observable/zip");
var of_1 = require("rxjs/observable/of");
var BehaviorSubject_1 = require("rxjs/BehaviorSubject");
require("./hierarchical-select-settings.component.scss");
var noop_1 = require("rxjs/util/noop");
var HierarchicalSelectSettingsComponent = /** @class */ (function (_super) {
    __extends(HierarchicalSelectSettingsComponent, _super);
    function HierarchicalSelectSettingsComponent(kbService, languageService, currentLanguageProvider, communicationService) {
        var _this = _super.call(this) || this;
        _this.kbService = kbService;
        _this.languageService = languageService;
        _this.currentLanguageProvider = currentLanguageProvider;
        _this.communicationService = communicationService;
        _this.selectedMetaField = undefined;
        _this.lastLevelCompatibleMetaFields = [];
        _this.selectableMetaFieldIndex = 1;
        _this.isVertical = true;
        _this.isReady = false;
        _this.densityValues = [
            { name: 'Loose', id: 'loose' },
            { name: 'Default', id: 'default' },
            { name: 'Compact', id: 'compact' },
        ];
        _this.controlDesignValues = [
            { name: 'Search', id: 'search' },
            { name: 'Drilldown', id: 'drillDown' },
            { name: 'Search & Drilldown', id: 'search-drillDown' },
        ];
        _this.currentLanguageId = null;
        _this.levelChange$ = new BehaviorSubject_1.BehaviorSubject(null);
        _this.defaultMetaGroup = new idm_kb_service_client_js_1.MetaGroup(null, 'de.default.meta.group', []);
        return _this;
    }
    HierarchicalSelectSettingsComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.levelChange$) {
            this.levelChange$.unsubscribe();
        }
    };
    HierarchicalSelectSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        var languages$ = this.languageService.getInputLanguages();
        var currentLanguageId$ = this.currentLanguageProvider.getCurrentLanguage();
        var selectedMetaFields$ = this.getSelectedMetaFields();
        combineLatest_1.combineLatest(languages$, currentLanguageId$, selectedMetaFields$)
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (data) {
            _this.languages = data[0];
            _this.currentLanguageId = data[1].getId();
            var selectedMetaFields = data[2];
            _this.hierarchicalSelectSetting = _this.getHierarchicalSelectSetting(selectedMetaFields);
            _this.isReady = true;
        }, function (err) { return console.error(err); });
        this.levelChangeSubscription();
    };
    HierarchicalSelectSettingsComponent.prototype.getMultilingualTitle = function (title) {
        if (title) {
            if (!(title instanceof idm_crosscutting_concepts_frontend_1.MultilingualString) && title !== '') {
                return utilities_1.stringToMultilingual(title);
            }
            else {
                return title;
            }
        }
        else {
            return idm_crosscutting_concepts_frontend_1.MultilingualString.newBuilder()
                .withValueForLanguages(this.languages.map(function (language) { return language.getId(); }), '')
                .build();
        }
    };
    HierarchicalSelectSettingsComponent.prototype.refreshCommunicationService = function () {
        this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
            metaField: undefined,
            bindings: this.getBindings(),
            state: this.getState(),
        }));
    };
    HierarchicalSelectSettingsComponent.prototype.addLevel = function () {
        this.hierarchicalSelectSetting.selectedMetaFields.push(this.selectedMetaField);
        this.selectedMetaField = undefined;
        this.selectableMetaFieldIndex =
            this.hierarchicalSelectSetting.selectedMetaFields.length + 1;
        this.levelChange$.next({
            selectedMetaField: this.selectedMetaField,
        });
    };
    HierarchicalSelectSettingsComponent.prototype.deleteLastLevel = function () {
        var lastIndex = this.hierarchicalSelectSetting.selectedMetaFields.length - 1;
        this.selectedMetaField = undefined;
        this.hierarchicalSelectSetting.selectedMetaFields.splice(-1);
        this.selectableMetaFieldIndex =
            this.hierarchicalSelectSetting.selectedMetaFields.length + 1;
        this.levelChange$.next({
            selectedMetaField: this.selectedMetaField,
        });
    };
    HierarchicalSelectSettingsComponent.prototype.changeOrientationValue = function (value) {
        this.isVertical = value;
    };
    HierarchicalSelectSettingsComponent.prototype.trackByFunc = function (index, selectedMetaField) {
        return selectedMetaField.getMetaFieldId();
    };
    HierarchicalSelectSettingsComponent.prototype.getSelectedMetaFields = function () {
        var _this = this;
        var entityCategorySystemName = this.state.entityCategorySystemName;
        var selectedItemFields = [];
        if (this.state.selectedItemFields !== '') {
            selectedItemFields =
                typeof this.state.selectedItemFields === 'string'
                    ? JSON.parse(this.state.selectedItemFields)
                    : this.state.selectedItemFields;
        }
        var selectedMetaFields = selectedItemFields.map(function (fieldSystemName) {
            var mockedMetaFieldId = new idm_kb_service_client_js_1.MetaFieldId(new idm_kb_service_client_js_1.MetaCategoryId(entityCategorySystemName), fieldSystemName);
            return _this.kbService.getMetaFieldByMetaFieldId(mockedMetaFieldId);
        });
        return selectedMetaFields.length > 0
            ? zip_1.zip.apply(void 0, selectedMetaFields) : of_1.of([]);
    };
    HierarchicalSelectSettingsComponent.prototype.getHierarchicalSelectSetting = function (selectedMetaFields) {
        var title = this.getMultilingualTitle(this.state.title);
        this.isVertical = !this.state.density;
        var density = this.state.density
            ? this.state.density
            : 'loose';
        var controlDesignValue = this.state.switchModes
            ? this.state.switchModes.join('-')
            : '';
        this.selectedMetaField = undefined;
        this.selectableMetaFieldIndex = selectedMetaFields.length + 1;
        return new model_1.HierarchicalSelectSettings(title, selectedMetaFields, density, controlDesignValue);
    };
    HierarchicalSelectSettingsComponent.prototype.levelInitialization = function () {
        var _this = this;
        return this.kbService.getNonSystemMetaFields(this.category).pipe(operators_1.first(), operators_1.mergeMap(function (metaFields) {
            return zip_1.zip(of_1.of(metaFields), _this.kbService.getNonSystemMetaGroups(_this.category), zip_1.zip.apply(void 0, metaFields.map(function (metaField) {
                return _this.isFieldCompatible(metaField);
            })));
        }), operators_1.map(function (_a) {
            var metaFields = _a[0], metaGroups = _a[1], compatibilityArray = _a[2];
            _this.lastLevelCompatibleMetaFields = metaFields
                .filter(function (metaField, index) {
                return compatibilityArray[index];
            })
                .map(function (metaField) {
                var metaGroup = metaGroups.find(function (group) {
                    return group.getSystemName() ===
                        metaField
                            .getMetaFieldId()
                            .getMetaGroupId()
                            .getSystemName();
                });
                return {
                    metaField: metaField,
                    metaGroup: metaGroup || _this.defaultMetaGroup,
                };
            });
        }));
    };
    /**
     * Child or Next Level Initialization
     */
    HierarchicalSelectSettingsComponent.prototype.nextLevelInitialization = function () {
        var _this = this;
        var categorySystemName = this.selectedMetaField.getCompoundCategorySystemName();
        this.kbService
            .getClassifierMetaCategories()
            .pipe(operators_1.mergeMap(function (metaCategories) {
            var metaCategoriesArray = Array.from(metaCategories.values());
            var metaCategorySystemNames = metaCategoriesArray.map(function (metaCategory) {
                return metaCategory.getSystemName();
            });
            var metaCategoryMetaFields$ = [];
            metaCategorySystemNames.forEach(function (systemName) {
                metaCategoryMetaFields$.push(_this.kbService.getMetaFields(systemName));
            });
            return zip_1.zip.apply(void 0, metaCategoryMetaFields$);
        }), operators_1.takeUntil(this.destroySubject$))
            .subscribe(noop_1.noop, function (error1) { return console.error(error1); });
    };
    HierarchicalSelectSettingsComponent.prototype.isFieldCompatible = function (metaField) {
        var _this = this;
        if (metaField.getType() !== idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER) {
            return of_1.of(false);
        }
        if (!this.hierarchicalSelectSetting.selectedMetaFields ||
            this.hierarchicalSelectSetting.selectedMetaFields.length === 0) {
            return of_1.of(true);
        }
        return this.kbService
            .getMetaFields(metaField.getCompoundCategorySystemName())
            .pipe(operators_1.map(function (classifierMetaFields) {
            var parentMetaField = classifierMetaFields.find(function (classifierMetaField) {
                return classifierMetaField.getType() ===
                    idm_kb_service_client_js_1.MetaFieldType.PARENT;
            });
            return !!(parentMetaField &&
                parentMetaField.getCompoundCategorySystemName() ===
                    _this.hierarchicalSelectSetting.selectedMetaFields[_this.hierarchicalSelectSetting
                        .selectedMetaFields.length - 1].getCompoundCategorySystemName());
        }));
    };
    HierarchicalSelectSettingsComponent.prototype.levelChangeSubscription = function () {
        var _this = this;
        var changedData;
        this.levelChange$
            .pipe(operators_1.mergeMap(function (levelChangeData) {
            changedData = levelChangeData;
            return _this.levelInitialization();
        }), operators_1.takeUntil(this.destroySubject$))
            .subscribe(function () {
            _this.isReady = true;
            if (changedData !== null) {
                _this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, {
                    metaField: null,
                    bindings: _this.getBindings(),
                    state: _this.getState(),
                    fields: _this.hierarchicalSelectSetting
                        .selectedMetaFields,
                }));
            }
        }, function (err) { return console.error(err); });
    };
    HierarchicalSelectSettingsComponent.prototype.getBindings = function () {
        return {};
    };
    HierarchicalSelectSettingsComponent.prototype.getState = function () {
        return {
            title: utilities_1.multilingualToString(this.hierarchicalSelectSetting.title),
            density: !this.isVertical
                ? this.hierarchicalSelectSetting.density
                : undefined,
            entityCategorySystemName: this.category,
            selectedItemCategories: this.hierarchicalSelectSetting.selectedMetaFields.map(function (metaField) {
                return metaField.getCompoundCategorySystemName();
            }),
            selectedItemFields: this.hierarchicalSelectSetting.selectedMetaFields.map(function (metaField) { return metaField.getSystemName(); }),
            switchModes: this.hierarchicalSelectSetting.controlDesign.split('-'),
        };
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HierarchicalSelectSettingsComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HierarchicalSelectSettingsComponent.prototype, "state", void 0);
    HierarchicalSelectSettingsComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'hierarchical-select-settings',
            template: require('./hierarchical-select-settings.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "<hierarchical-select-settings\n                [category]=\"%{category}\"\n                [state]=\"%{state}\">\n             </hierarchical-select-settings>",
        }),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_message_language_service_client_js_1.LanguageService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_dynamic_controls_metadata_1.CommunicationService])
    ], HierarchicalSelectSettingsComponent);
    return HierarchicalSelectSettingsComponent;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.HierarchicalSelectSettingsComponent = HierarchicalSelectSettingsComponent;
//# sourceMappingURL=hierarchical-select-settings.component.js.map